import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import styles from './Preview.css'

export default class Preview extends Component {
  static propTypes = {
    code: PropTypes.string.isRequired
  }

  componentDidMount () {
    this.executeCode()
    this.refs.preview.style.minHeight = this.refs.preview.offsetHeight
  }

  componentDidUpdate (prevProps) {
    if (this.props.code !== prevProps.code) {
      setTimeout(() => {
      /* timeout/throttle for live code editor */
      this.executeCode()
      }, 500)
    }
  }

  compileCode () {
    // console.log('this.props', this.props)

    if (this.props.component) {
      // returns raw components in dom
      return Babel.transform( // eslint-disable-line
        `(function() { return (${
            this.props.code  })` +
        '\n})();', { presets: ['es2015', 'react'] }
      ).code
    }
      // returns react component to eval
      let cleanCode = this.props.code.replace(/^import(.*)/gm, '')
      cleanCode = cleanCode.replace('export default ', '')
      const demoClass = cleanCode.match(/class(.*)extends/)
      const renderComponent = demoClass[1].trim()
      // console.log('cleanCode', cleanCode)
      // console.log('renderComponent', renderComponent)


      const code = Babel.transform( // eslint-disable-line
          `(function() { \n${
              cleanCode  }\nreturn <${renderComponent} />;` +
          '\n})();', { presets: ['es2015', 'react'] }
      ).code

      // console.log(code)

      return code

  }
  executeCode () {
    const node = this.refs.preview
    try {
      ReactDOM.unmountComponentAtNode(node)
    } catch (e) { }

    try {
      const what = this.compileCode()
      // console.log('what', what)
      var compiledCode = eval(this.compileCode()) // eslint-disable-line
      // console.log('compiledCode', typeof compiledCode)
      const pathname = this.props.path.match(/([^\/?]+)(?=\/?(?:$|\?))/gm)
      let exampleTitle = this.props.name

      if (pathname) {
        exampleTitle = pathname[0]
        exampleTitle = exampleTitle.replace(/[\d](.*)_/, '')
        exampleTitle = exampleTitle.replace('.js', '')
        exampleTitle = exampleTitle.replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
      }
      ReactDOM.render(compiledCode, node)
    } catch (err) {
      setTimeout(() => {
        ReactDOM.render(
          <div className={styles.error}>
            <h3>Syntax error!
              <span className={styles.resetCode} onClick={this.props.reset}>
                reset code
              </span>
            </h3>
            <pre>{err.toString()}</pre>
          </div>,
          node
        )
      }, 500)
    }
  }
  render () {
    return (
      <div className={styles.preview} ref='preview' />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Preview/Preview.js